<template>
  <a @click="$refs.modalTest.openModal()">
    <ImageMagnifier
      :alt="alt"
      height="auto"
      mask-bg-color="#434140"
      mask-height="70"
      mask-width="70"
      :orientation="zoomorientation"
      :scale="2"
      :src="imagesrc"
      width="100%"
      :zoom-src="imagezoom"
    />
  </a>
  <Modal ref="modalTest" :is-modal-open="isModalOpen" @close-modal="closeModal">
    <img alt="" :src="currentSrc" />
  </Modal>
</template>

<script setup>
import Modal from '../../components/Modal/Modal.vue';
import ImageMagnifier from '../../components/ImageMagnifier/ImageMagnifier.vue';

defineProps({
  alt: {
    type: String,
    default: '',
  },
  imagesrc: {},
  imagezoom: {},
  zoomorientation: {
    type: String,
    default: '',
  },
});

let isModalOpen = false;
let currentSrc = null;

function closeModal() {
  isModalOpen = false;
  currentSrc = null;
}
</script>
